import EditSVG from "@design-system/ui-icons/vanilla/Edit"
import { createIcon } from "../createIcon"

export const EditIcon = createIcon(EditSVG)
